import { theme } from '@kijiji/theme'
import { type HTMLAttributes } from 'react'
import styled from 'styled-components'

import { CONDENSED_APP_WIDTH, FULL_MAX_APP_WIDTH, MAX_APP_WIDTH } from '@/constants/others'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'
import { applyResponsiveStyle } from '@/ui/helpers/applyResponsiveStyle'
import { type ResponsiveProp } from '@/ui/typings/helpers'

type PageContainerWrapperProps = HTMLAttributes<HTMLDivElement> & {
  $bottom: ResponsiveProp<string>
  $top: ResponsiveProp<string>
  $isCondensed: boolean
  $isFullMax: boolean
  $removeMobilePadding?: boolean
}

export const PAGE_CONTAINER_HORIZONTAL_MOBILE_SPACING = theme.spacing.default

const getResponsiveMarginTop = (value: string) => `margin-top: ${value};`
const getResponsiveMarginBottom = (value: string) => `margin-bottom: ${value};`

export const PageContainerWrapper = styled.div<PageContainerWrapperProps>(
  ({ theme, $bottom, $top, $isCondensed, $isFullMax, $removeMobilePadding }) => `
  margin: 0 auto;

  max-width: 100%;
  padding: ${$removeMobilePadding ? '0' : `0 ${PAGE_CONTAINER_HORIZONTAL_MOBILE_SPACING}`};
  width: 100%;
  
  ${MEDIA_QUERIES(theme).medium} {
    max-width: ${($isCondensed && CONDENSED_APP_WIDTH) || ($isFullMax && FULL_MAX_APP_WIDTH) || MAX_APP_WIDTH};
    padding: ${$isCondensed ? '0 6rem' : `0 ${theme.spacing.husky}`};
  }
  ${MEDIA_QUERIES(theme).xLarge} {
    margin: ${theme.spacing.default} auto 3rem;
    max-width: ${($isCondensed && CONDENSED_APP_WIDTH) || ($isFullMax && FULL_MAX_APP_WIDTH) || MAX_APP_WIDTH};
    padding: ${$isCondensed ? '0 6rem' : '0 8rem'};
  }

  ${applyResponsiveStyle($top, theme, getResponsiveMarginTop)}
  ${applyResponsiveStyle($bottom, theme, getResponsiveMarginBottom)}
`
)
